import Vue from 'vue'
import Component from 'vue-class-component'
import UserHeader from '../shared/UserHeader.vue'
import ConvoReferences from './ConvoReferences.vue'
import ConvoTags from './ConvoTags.vue'
import convoStore from '@/store/convo/convo-store'
import EditButton from '@/components/buttons/EditButton'
import CancelButton from '@/components/buttons/CancelButton.vue'
import StatementView from '@/components/statement/StatementView.vue'
import statementStore from '@/store/statement/statement-store';
import feedStore from '@/store/feed/feed-store';

@Component({
  name: 'convoView',
  props: [],
  components: {
    'user-header': UserHeader,
    'convo-references': ConvoReferences,
    'convo-tags': ConvoTags,
    'statement-view': StatementView,
    'edit-button' : EditButton,
    'cancel-button' : CancelButton
  }
})
export default class ConvoStatementEdit extends Vue {
  protected topFocused = true;
  protected cancelScroll: any;

  mounted (): void {
    console.log('ConvoStatementEdit.ts: mounted')

    this.$store.subscribe((mutation, state) => {
      console.log('ConvoStatementEdit mutation: type = %j', mutation.type)
      if (mutation.type === 'statement/setStatements') {
        console.log('ConvoStatementEdit mutation: feed type = %j', feedStore.state.feedType)
        if(feedStore.state.feedType === 'convo-statement-edit') {
          console.log('ConvoStatementEdit mutation: hiding statements')
          convoStore.dispatchHideConvoStatements();
          this.cancelScroll = (this as any).$scrollTo('#top')
        }
      }
    })
  }

  get convo () {
    return convoStore.state.convo;
  }

  get statements () { return statementStore.state.statements }

  protected stopEdit (): void {
    feedStore.dispatchViewConvos();
  }
}
